/**
 * ProductUnitItem을 VerticalProductTabItemProps로 변환하는 유틸리티 함수입니다.
 */
import type { ProductUnitItem } from '@weberus/shared-types';
import type { VerticalProductTabItemProps } from '@weberus/ui/components';

export const convertProductUnitToVerticalProps = (items: ProductUnitItem[]): VerticalProductTabItemProps[] => {
  return items.map((item) => ({
    id: item.data.id,
    title: item.data.title,
    action: item.data.action,
    discountRate: item.data.prices[0].discountRate || '',
    price: {
      text: item.data.prices[0].closedInformation || item.data.prices[0].discountPrice || '',
      isValid: !item.data.prices[0].closedInformation,
    },
    priceUnit: item.data.prices[0].discountPriceUnit || '',
    imageUrl: item.data.thumbnail,
    hasGoldClassBadge: item.data.benefitBadges?.some((badge) => badge.type === 'THUMBNAIL_MEMBER_CLASS_GOLD'),
    score: item.data.review?.score,
    reviewCount: item.data.review?.count,
    badgeText: item.data.thumbnailBadges?.[0]?.text || '',
    description: item.data.descriptions?.[0] || '',
    generalTypeWidth: 175,
    mobileRatio: '3_4',
  }));
};
